import moment from 'moment'
import { divideInNIntegers, safeAdd } from '../../../common/mathHelper'
import { backGroundColor } from '../../../common/helper'
const TOTAL_FIELDS = [
  'NOP',
  'Freight',
  'DocumentCharges',
  'CartageAmount',
  'HamaliCharges',
  'OperatorHamaliChg',
  'Valuation',
  'OtherCharges',
  'ServiceTaxAmount',
  'NetAmount',
]

const groupBy = (list = [], ...keys) =>
  list.reduce((acc, item) => {
    const groupKey = keys
      .map((k) => item?.[k])
      .filter((v) => !!v)
      .join('§')
    if (!groupKey) return acc
    acc[groupKey] ??= []
    acc[groupKey].push(item)
    return acc
  }, {})

export const accumulateTotals = (rows = [], fields) =>
  rows.reduce((acc, row) => {
    fields.forEach((field) => {
      acc[field] = safeAdd(acc[field], Number(row[field] || 0))
    })
    return acc
  }, Object.fromEntries(fields.map((f) => [f, 0])))

const buildCityWiseReport = (rows = [], headers, filterData) => {
  const bookingCityGroups = groupBy(rows, 'BookingCity')
  const bookingCities = Object.keys(bookingCityGroups).sort()

  const lengths = divideInNIntegers(headers.length, 4)
  const pickedHeaders = []
  let index = 0
  lengths.forEach((span) => {
    pickedHeaders.push(headers[index].field)
    index += span
  })

  let output = []
  let grandTotals = Object.fromEntries(TOTAL_FIELDS.map((f) => [f, 0]))

  bookingCities.forEach((bookingCity) => {
    const bookingCityRows = bookingCityGroups[bookingCity]
    const destinationGroups = groupBy(bookingCityRows, 'DestinationCity')
    const destinationCities = Object.keys(destinationGroups).sort()
    destinationCities.forEach((destCity) => {
      const pairRows = destinationGroups[destCity].sort((a, b) => moment(a.BookingDateTime).valueOf() - moment(b.BookingDateTime).valueOf())
      const entries = pairRows.map((item, index) => ({
        ...item,
        // 'LastStatus^^DaysInterval': (
        //   <>
        //     <span
        //       style={{
        //         backgroundColor: backGroundColor[item.LastStatus],
        //         padding: '2px 6px 1px 6px',
        //         whiteSpace: 'nowrap',
        //         display: 'inline-flex',
        //         borderRadius: '10px',
        //         fontWeight: '500',
        //       }}
        //     >
        //       {item.LastStatus}
        //     </span>
        //     <span style={{ display: 'block', paddingLeft: '6px' }}>{item.DaysInterval}</span>
        //   </>
        // ),
        srNo: index + 1,
        dataType: 'entry',
      }))

      const totals = accumulateTotals(entries, TOTAL_FIELDS)
      TOTAL_FIELDS.forEach((f) => {
        grandTotals[f] += totals[f]
      })
      output.push(
        {
          [pickedHeaders[0]]: `Current State:${entries[0].StateName}`,
          [pickedHeaders[1]]: `Src. City: ${bookingCity}`,
          [pickedHeaders[2]]: `Dest. City: ${destCity}`,
          [pickedHeaders[3]]: `${filterData.IncludeDate
            ? 'Booking Date:' + `${filterData.FromDate} to ${filterData.ToDate}`
            : 'Financial Year:' + filterData.financialYear
            }`,
          dataType: 'subHeader',
          align: { [pickedHeaders[3]]: 'right' },
          colSpan: Object.fromEntries(pickedHeaders.map((key, i) => [key, lengths[i] || 1])),
          totalSubKey: 4,
        },
        ...entries,
        {
          [headers[0].field]: `TOTAL: Src. City: ${bookingCity} / Dest. City: ${destCity}`,
          align: { [headers[0].field]: 'right' },
          dataType: 'total',
          colSpan: { [headers[0].field]: headers.findIndex((item) => item.field === 'NOP') },
          ...Object.fromEntries(TOTAL_FIELDS.map((f) => [f, totals[f].toFixed(2)])),
        }
      )
    })
  })

  const grandTotalRow = {
    dataType: 'total',
    align: { [headers[0].field]: 'right' },
    [headers[0].field]: 'TOTAL: Src. City: All / Dest. City: All',
    colSpan: { [headers[0].field]: headers.findIndex((item) => item.field === 'NOP') },
    ...Object.fromEntries(TOTAL_FIELDS.map((f) => [f, grandTotals[f].toFixed(2)])),
  }

  return { output, grandTotals, grandTotalRow }
}

export function cityWiseGroup(arr = [], arr2 = [], headers, filterData) {
  const r1 = buildCityWiseReport(arr, headers, filterData)

  if (!Array.isArray(arr2) || arr2.length === 0) {
    return [...r1.output, r1.grandTotalRow]
  }

  const r2 = buildCityWiseReport(arr2, headers, filterData)

  const mergedTotals = Object.fromEntries(
    TOTAL_FIELDS.map((f) => [f, (Number(r1.grandTotals[f] || 0) + Number(r2.grandTotals[f] || 0)).toFixed(2)])
  )

  const finalGrandTotalRow = {
    ...r1.grandTotalRow,
    ...mergedTotals,
  }

  return [
    {
      dataType: 'header',
      caption: 'Booked but Pending Dispatch',
      colSpan: headers.length,
    },
    ...r1.output,
    {
      dataType: 'header',
      caption: 'Received But Pending Dispatch',
      colSpan: headers.length,
    },
    ...r2.output,
    finalGrandTotalRow,
  ]
}

const PAYMENT_SUMMARY_TOTAL_KEYS = [
  'TotalLRCount',
  'TotalNOP',
  'TotalFreight',
  'TotalDocumentCharges',
  'TotalCartageAmount',
  'TotalHamaliCharges',
  'TotalOperatorHamaliChg',
  'TotalValuation',
  'TotalOtherCharges',
  'TotalServiceTaxAmount',
  'TotalNetAmount',
]
export const paymentSummaryData = (tableData = [], headers, filterData) => {
  const rows = []

  const totalRow = {
    dataType: 'total',
    colSpan: { [headers[0].field]: 2 },
    [headers[0].field]: `TOTAL:${filterData?.paymentTypeName}`,
    align: { [headers[0].field]: 'right' },
  }

  PAYMENT_SUMMARY_TOTAL_KEYS.forEach((key) => {
    totalRow[key] = 0
  })

  tableData.forEach((obj, index) => {
    rows.push({
      dataType: 'entry',
      sNo: index + 1,
      ...obj,
    })

    PAYMENT_SUMMARY_TOTAL_KEYS.forEach((key) => {
      totalRow[key] += Number(obj[key] || 0)
    })
  })

  return [...rows, totalRow]
}

const PAYMENT_TOTAL_FIELDS = ['NOP', 'NetAmount']
const aggregateByPaymentType = (rows = []) =>
  Object.values(groupBy(rows, 'PaymentType')).map((list) => ({
    ...list[0],
    ...accumulateTotals(list, PAYMENT_TOTAL_FIELDS),
  }))

export const branchSummaryData = (rows = [], headers, filterData) => {
  if (!rows.length) {
    return [
      {
        dataType: 'entry',
        caption: 'No Records',
        align: { [headers[0].field]: 'center' },
        colSpan: { [headers[0].field]: headers.length },
      },
    ]
  }
  const lengths = divideInNIntegers(headers.length, 4)
  const pickedHeaders = []
  let index = 0
  lengths.forEach((span) => {
    pickedHeaders.push(headers[index].field)
    index += span
  })
  const bySource = groupBy(rows, 'BookingBranch')
  const output = []
  let grandTotals = { NOP: 0, NetAmount: 0 }

  Object.values(bySource).forEach((sourceRows) => {
    const byDest = groupBy(sourceRows, 'DestinationBranch')

    Object.entries(byDest).forEach(([destBranch, destRows]) => {
      const paymentRows = aggregateByPaymentType(destRows)
      const totals = accumulateTotals(paymentRows, PAYMENT_TOTAL_FIELDS)
      output.push(
        {
          [pickedHeaders[0]]: `City:${sourceRows[0].BookingCity}`,
          [pickedHeaders[1]]: `Src. Branch: ${sourceRows[0].BookingBranch}`,
          [pickedHeaders[2]]: `Dest. Branch: ${destBranch}`,
          [pickedHeaders[3]]: `${filterData.IncludeDate
            ? 'Booking Date:' + `${filterData.FromDate} to ${filterData.ToDate}`
            : 'Financial Year:' + filterData.financialYear
            }`,
          dataType: 'subHeader',
          align: { [pickedHeaders[3]]: 'right' },
          colSpan: Object.fromEntries(pickedHeaders.map((key, i) => [key, lengths[i] || 1])),
        },

        ...paymentRows.map((row, i) => ({
          ...row,
          dataType: 'entry',
          srNo: i + 1,
        })),
        {
          [headers[0].field]: `Total: Src. Br. : ${sourceRows[0].BookingBranch} / Dest. Br.: ${destBranch}`,
          align: { [headers[0].field]: 'right' },
          dataType: 'total',
          colSpan: { [headers[0].field]: headers.findIndex((item) => item.field === 'NOP') },
          NOP: totals.NOP.toFixed(2),
          NetAmount: totals.NetAmount.toFixed(2),
        }
      )
      grandTotals.NOP += totals.NOP
      grandTotals.NetAmount += totals.NetAmount
    })
  })

  output.push({
    dataType: 'total',
    align: { [headers[0].field]: 'right' },
    [headers[0].field]: 'Total: Src. Br. : ALL / Dest. Br.: All',
    colSpan: {
      [headers[0].field]: headers.findIndex((item) => item.field === 'NOP'),
    },
    NOP: grandTotals.NOP.toFixed(2),
    NetAmount: grandTotals.NetAmount.toFixed(2),
  })

  return output
}

const STATUS_FIELD_MAP = {
  B: ['totalLRB', 'totalUnitB', 'totalNetAmtB'],
  D: ['totalLRD', 'totalUnitD', 'totalNetAmtD'],
  R: ['totalLRR', 'totalUnitR', 'totalNetAmtR'],
  DR: ['totalLRDR', 'totalUnitDR', 'totalNetAmtDR'],
  BR: ['totalLRDR', 'totalUnitDR', 'totalNetAmtDR'],
}
const TOTAL_FIELDS_STATUS = Object.values(STATUS_FIELD_MAP)
  .flat()
  .filter((v, i, a) => a.indexOf(v) === i)

const accumulateByStatus = (rows = []) =>
  rows.reduce((acc, row) => {
    const fields = STATUS_FIELD_MAP[row.StatusCode]
    if (!fields) return acc
    acc[fields[0]] += 1
    acc[fields[1]] = safeAdd(acc[fields[1]], Number(row.NOP))
    acc[fields[2]] = safeAdd(acc[fields[2]], Number(row.NetAmount))
    return acc
  }, Object.fromEntries(TOTAL_FIELDS_STATUS.map((f) => [f, 0])))
const buildGroupRows = (data, headers, filterData) => {
  const byPayment = groupBy(data, 'BookingBranch', 'DestinationBranch', 'PaymentType')
  const lengths = divideInNIntegers(headers.length, 4)
  const pickedHeaders = []
  let index = 0
  lengths.forEach((span) => {
    pickedHeaders.push(headers[index].field)
    index += span
  })
  let groupTotal = Object.fromEntries(TOTAL_FIELDS_STATUS.map((f) => [f, 0]))

  const rows = Object.values(byPayment).map((list, index) => {
    const totals = accumulateByStatus(list)

    groupTotal = accumulateTotals([groupTotal, totals], TOTAL_FIELDS_STATUS)

    return {
      dataType: 'entry',
      sNo: index + 1,
      BookingBranch: list[0].BookingBranch,
      DestinationBranch: list[0].DestinationBranch,
      PaymentType: list[0].PaymentType,
      ...totals,
    }
  })

  return [
    {
      dataType: 'subHeader',
      [pickedHeaders[0]]: `State: ${data[0].StateName}`,
      [pickedHeaders[1]]: `City: ${data[0].CurrentCity}`,
      [pickedHeaders[2]]: `Branch: ${data[0].CurrentBranch}`,
      [pickedHeaders[3]]: filterData.IncludeDate ? `${filterData.FromDate} to ${filterData.ToDate}` : filterData.financialYear,
      align: { [pickedHeaders[3]]: 'right' },
      colSpan: Object.fromEntries(pickedHeaders.map((key, i) => [key, lengths[i] || 1])),
    },

    ...rows,

    {
      dataType: 'total',
      [pickedHeaders[0]]: `TOTAL: ${data[0].CurrentBranch}`,
      align: { [pickedHeaders[0]]: 'right' },
      colSpan: { [pickedHeaders[0]]: 4 },
      ...groupTotal,
    },
  ]
}
const buildGroupedFieldMap = (groupedHeader = []) => {
  const map = {}

  groupedHeader.forEach((group) => {
    if (!Array.isArray(group.children) || group.children.length === 0) return

    map[group.children[0].field] = {
      title: group.header,
      span: group.colSpan,
    }
  })

  return map
}
export const buildStatusWiseHeaderRows = (headers, groupedHeader) => {
  const groupedMap = buildGroupedFieldMap(groupedHeader)
  const row1 = {
    dataType: 'header',
    colSpan: {},
    align: {},
  }

  headers.forEach((h) => {
    const grp = groupedMap[h.field]
    if (grp) {
      row1[h.field] = grp.title
      row1.colSpan[h.field] = grp.span
      row1.align[h.field] = 'center'
    } else {
      row1[h.field] = h.header
    }
  })

  const row2 = { dataType: 'header' }

  headers.forEach((h) => {
    if (h.align === 'left') {
      row2[h.field] = ''
    } else {
      row2[h.field] = h.header
    }
  })

  return [row1, row2]
}

export const statusWiseSummaryData = (data, headers, filterData, groupedHeader) => {
  const grouped = groupBy(data, 'CurrentCity', 'CurrentBranch')
  let result = []
  const [groupHeaderRow, subHeaderRow] = buildStatusWiseHeaderRows(headers, groupedHeader)
  result.push(groupHeaderRow, subHeaderRow)
  let grandTotal = Object.fromEntries(TOTAL_FIELDS_STATUS.map((f) => [f, 0]))
  Object.values(grouped).forEach((group) => {
    const section = buildGroupRows(group, headers, filterData)
    result.push(...section)

    section
      .filter((r) => r.dataType === 'total')
      .forEach((t) => {
        grandTotal = accumulateTotals([grandTotal, t], TOTAL_FIELDS_STATUS)
      })
  })
  result.push({
    dataType: 'total',
    [headers[0].field]: `TOTAL: ${filterData.BranchName}`,
    colSpan: { [headers[0].field]: 4 },
    align: { [headers[0].field]: 'right' },
    ...grandTotal,
  })
  return result
}
